// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__48-EZ","label":"Category_label__21MvM","content":"Category_content__btuAV","header":"Category_header__H93Ra","location":"Category_location__3v5kZ"};